module.exports = __webpack_public_path__ + "static/media/logo_client.5a8d21b4.png";